// extracted by mini-css-extract-plugin
module.exports = {"columns":"x_rLuuNX5L-columns-theme-landing-columns","columnsLeft":"_1B8Vpe7v2e-columns-theme-landing-columnsLeft","columnsRight":"XUgxPlzU7w-columns-theme-landing-columnsRight"};